module.exports = __webpack_public_path__ + "img/movie-cinema.3ffcf053.png";